// stores/useMapStore.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMapStore = defineStore('mapStore', () => {
  // Tracks if the user has manually interacted with the map (pan, zoom)
  const userHasInteracted = ref(false)

  // Sets the interaction flag to true
  function setUserInteracted() {
    userHasInteracted.value = true
  }

  // Resets the interaction flag to false (e.g., on new search)
  function resetUserInteraction() {
    userHasInteracted.value = false
  }

  return {
    userHasInteracted,
    setUserInteracted,
    resetUserInteraction,
  }
})
